/* eslint-disable react/no-unescaped-entities */

export const referaItems = ({ budget, hasExtendedWarranty }) => {
  return [
    {
      label: 'Tarifa regular',
      fields: [
        {
          type: 'percentage-input',
          name: 'referaRegularTaxPercentage',
          value: budget?.referaRegularTaxPercentage,
          complementName: 'referaRegularTax',
        },
        {
          type: 'currency-input',
          name: 'referaRegularTax',
          value: budget?.referaRegularTax,
          complementName: 'referaRegularTaxPercentage',
        },
      ],
    },
    {
      label: 'Tarifa dinâmica',
      fields: [
        {
          type: 'percentage-input',
          name: 'additionalTakeRatePerc',
          value: budget?.additionalTakeRatePerc,
          complementName: 'additionalTakeRate',
        },
        {
          type: 'currency-input',
          name: 'additionalTakeRate',
          value: budget?.additionalTakeRate,
          complementName: 'additionalTakeRatePerc',
        },
      ],
    },
    {
      label: 'Garantia',
      fields: [
        {
          type: 'currency-input',
          name: 'warrantyValue',
          value: budget?.warrantyValue,
          complementName: null,
        },
      ],
    },
    hasExtendedWarranty && {
      label: 'Garantia estendida',
      fields: [
        {
          type: 'switch',
          name: 'extendedWarranty',
          value: budget?.extendedWarranty,
          complementName: null,
        },
        {
          type: 'currency-input',
          name: 'extendedWarrantyValue',
          value: budget?.extendedWarrantyValue,
          complementName: null,
        },
      ],
    },
    {
      label: 'Revenue share',
      fields: [
        {
          type: 'currency-read',
          name: 'revenueShare',
          value: budget?.revenueShare,
          complementName: null,
        },
      ],
    },
  ].filter(Boolean)
}

export const secondaryItems = ({ budget }) => {
  return [
    {
      label: 'Tarifa da intermediária',
      boldLabel: true,
      fields: [
        {
          type: 'percentage-input',
          name: 'agencyCompletionPercentage',
          value: budget?.agencyCompletionPercentage,
          complementName: 'agencyCompletionPercentageValue',
        },
        {
          type: 'currency-input',
          name: 'agencyCompletionPercentageValue',
          value: budget?.agencyCompletionPercentageValue,
          complementName: 'agencyCompletionPercentage',
        },
      ],
    },
  ]
}

export const saasItems = ({ budget }) => {
  return [
    {
      label: 'Tarifa da intermediária',
      boldLabel: true,
      fields: [
        {
          type: 'percentage-input',
          name: 'agencyCompletionPercentage',
          value: budget?.agencyCompletionPercentage,
          complementName: 'agencyCompletionPercentageValue',
        },
        {
          type: 'currency-input',
          name: 'agencyCompletionPercentageValue',
          value: budget?.agencyCompletionPercentageValue,
          complementName: 'agencyCompletionPercentage',
        },
      ],
    },
  ]
}
